/* eslint-disable react-hooks/exhaustive-deps */

import React, {cloneElement, useCallback, useEffect, useState} from "react";
import {Link, Redirect, Route, Switch, useLocation, useRouteMatch} from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import ToggleLabels from "./toggleLabels";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import usePersistentStore from "../../../persistentStore";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import useLayoutStore from "../../../layoutStore";
import Toolbar from "@material-ui/core/Toolbar";

const inIFrame = (window.parent.window !== window);

const useStyles = makeStyles(theme => ({
    grow: {
        flexGrow: 1,
    },
    appBar: {
        display: 'flex',
    },
    appBarHide: {
        display: 'none',
    },
    title: {
        marginRight: 10,
    },
    tabs: {
        minHeight: 36,
        '& .MuiTab-root': {
            minWidth: 'auto',
            minHeight: 36,
            fontSize: '0.6rem',
        },
    },
    textbox: {
        paddingLeft: 0,
        paddingRight: 0
    },
    noMargin: {
        marginBottom: 0,
        minHeight: 0
    },
}));

const TabPanel = props => {
    const {children, value, index, textboxClass, ...other} = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && <Box className={textboxClass} pt={inIFrame ? 0 : 2}>{children}</Box>}
        </Typography>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

const DetailTabs = props => {
    const classes = useStyles();
    let {url} = useRouteMatch();
    const [tabIndex, setTabIndex] = useState(0);
    const [globalPersistentState] = usePersistentStore();
    // eslint-disable-next-line no-unused-vars
    const [globalLayoutState, globalLayoutActions] = useLayoutStore();
    let location = useLocation();

    const setMyHeight = () => {
        const tb = document.getElementById('detailTabBar');
        if (tb) globalLayoutActions.setDetailTabBarHeight(tb.clientHeight);
    };

    const rectCallbackRef = useCallback(node => {
        setMyHeight();
    }, []);

    useEffect(() => {
        setMyHeight();
    }, [globalPersistentState.showDetailTabLabels]);

    const handleChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };

    useEffect(() => {
        Object.keys(props.parent.routes).map((key, idx) => {
            const route = props.parent.routes[key];
            if (location.pathname.indexOf(`${url}${route.path}`) === 0) {
                setTabIndex(idx);
            }
            return null;
        })
    }, [location.pathname, props.parent.routes, url]);

    return (
        <div>
            <AppBar id="detailTabBar" ref={rectCallbackRef} position="static" color="default"
                    className={globalLayoutState.editMode ? classes.appBarHide : classes.appBar}>
                <Toolbar variant={"dense"} className={classes.noMargin}>
                    <ToggleLabels/>
                    <Typography
                        variant="h6"
                        color="inherit"
                        className={classes.title}
                    >
                        {globalPersistentState.detailTabsTitle ? globalPersistentState.detailTabsTitle + ' ' : ''}{props.parent.title}
                    </Typography>
                    <div className={classes.grow}/>
                    <Tabs
                        value={tabIndex}
                        className={classes.tabs}
                        onChange={handleChange}
                        variant="scrollable"
                        scrollButtons="on"
                        indicatorColor="primary"
                        textColor="primary"
                        aria-label="tabs"
                    >
                        {Object.keys(props.parent.routes).map((key, idx) => {
                            const route = props.parent.routes[key];
                            if (route.component) {
                                return (
                                    <Tab
                                        key={idx}
                                        icon={route.icon}
                                        label={globalPersistentState.showDetailTabLabels ? route.title : null}
                                        id={route.title.replace(/\s+/g, '-').toLowerCase()}
                                        name={route.title.replace(/\s+/g, '-').toLowerCase()}
                                        aria-label={route.title.replace(/\s+/g, '-').toLowerCase()}
                                        component={Link}
                                        to={`${url}${route.path}`}
                                        {...a11yProps(idx)}
                                    />
                                )
                            }
                            return null;
                        })}
                    </Tabs>
                </Toolbar>
            </AppBar>
            <Switch>
                <Redirect exact from={props.parent.redirectMatch} to={`${url}${props.parent.redirectSlash}`}/>
                {Object.keys(props.parent.routes).map((key, idx) => {
                    const route = props.parent.routes[key];
                    return (
                        <Route key={idx} path={`${url}${route.path}`}>
                            <TabPanel
                                id={`tp-${idx}`}
                                key={idx}
                                value={tabIndex}
                                index={idx}
                            >
                                {cloneElement(route.component, {
                                    ...props,
                                    parent: route
                                })}
                            </TabPanel>
                        </Route>
                    )
                })}
            </Switch>
        </div>
    )
};

export default DetailTabs
